import React, { CSSProperties, useCallback, useState } from 'react'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { FieldRenderProps } from 'react-final-form'
import { Form, FormFieldProps, Label } from 'semantic-ui-react'
import { IRequirement, RequirementFormValues, RequirementsFormValues } from '../../models/Requirements';
import { Container } from '../DnD/container';

interface Iprops extends FieldRenderProps<string, HTMLElement>,
    FormFieldProps {
    id3: string;
}

const DnDInput: React.FC<Iprops> = ({
    input,
    width,
    meta: { touched, error },
    formId
}) => {

    const [fieldId] = useState(formId)

    const setInputValue = useCallback(
        (value: string) => {
            let obj = JSON.parse(value)

            let currentState: number = 1;

            let newRequirement: IRequirement[] = obj.map((val: { id: number, text: string; }) => {
                if (val.text === "Divider") {
                    currentState++;
                    return
                }
                else {
                    return new RequirementFormValues(val.text, currentState);
                }
            })

            newRequirement = newRequirement.filter(Boolean);
            let requirements = JSON.stringify(new RequirementsFormValues(newRequirement))

            input.onChange(requirements);
        },
        [input.value],
    )

    const hidden: CSSProperties = {
        display: 'none',
    };

    return (
        <Form.Field error={touched && !!error} width={width} >
            <input id={fieldId!.toString()} style={hidden} />
            
            <DndProvider backend={HTML5Backend}>
                <Container items={
                    JSON.parse(input.value).Requirement
                        .map((val: { Flag: string; Group: number; }, indx: number, list: any) => {

                            if (indx != 0 && val.Group != list[indx - 1].Group) {
                                return ["Divider", val.Flag]
                            }
                            else {
                                return val.Flag
                            }
                        }).flat()
                }
                    getNewValue={setInputValue}
                />
            </DndProvider>

            {touched && error && (
                <Label basic color='red'>
                    {error}
                </Label>
            )}
        </Form.Field>
    );
};
export default DnDInput;
